import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/shared/Header";
import { Button } from "../../components/ui/button";
import { DetailsFields } from "../../components/expenses/ExpenseFormFields";
import { useEvents } from "../../context/EventContext";
import { useExpenseForm } from "../../context/ExpenseFormContext";

export function ExpenseStepDetails() {
  const { eventId, expenseId } = useParams<{
    eventId: string;
    expenseId?: string;
  }>();
  const navigate = useNavigate();
  const { currentEvent } = useEvents();
  const {
    description,
    amount,
    paidById,
    setDescription,
    setAmount,
    setPaidById,
  } = useExpenseForm();

  // Initialize default payer to first participant if not set
  useEffect(() => {
    if (!currentEvent) return;
    const firstParticipant = currentEvent.participants[0];
    if (!paidById && firstParticipant) {
      setPaidById(firstParticipant.id);
    }
  }, [paidById, currentEvent, setPaidById]);

  if (!currentEvent) return null;

  const { participants, currency } = currentEvent;
  const parentRoute = `/event/${eventId}/expenses`;
  const isEdit = Boolean(expenseId);
  const title = isEdit ? "Editar gasto" : "Nuevo gasto";

  const isValid = description.trim() && amount > 0 && paidById;
  const validationMessage = !description.trim()
    ? "Ingresa una descripción"
    : amount <= 0
    ? "Ingresa un monto válido"
    : !paidById
    ? "Selecciona quién pagó"
    : null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isValid) {
      navigate("../step-2");
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header
        title={title}
        onBack={() => navigate(parentRoute)}
        variant="prominent"
      />
      <main className="flex-1 px-4 pt-4 pb-[calc(1rem+env(safe-area-inset-bottom))]">
        <form onSubmit={handleSubmit} className="space-y-4">
          <p className="text-sm text-muted-foreground">Paso 1 de 2</p>

          <DetailsFields
            description={description}
            amount={amount}
            paidById={paidById}
            currency={currency}
            participants={participants}
            onChangeDescription={setDescription}
            onChangeAmount={setAmount}
            onChangePaidBy={setPaidById}
          />

          {validationMessage && (
            <p className="text-sm text-muted-foreground">{validationMessage}</p>
          )}

          <div className="flex gap-2 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => navigate(parentRoute)}
              className="flex-1"
            >
              Cancelar
            </Button>
            <Button type="submit" disabled={!isValid} className="flex-1">
              Siguiente
            </Button>
          </div>
        </form>
      </main>
    </div>
  );
}
